// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__27fzO","cell":"ColumnAccessor_cell__2jZ-e","firstCellAccent":"ColumnAccessor_firstCellAccent__MNYAo"};